import React, { useState, useEffect } from 'react';

// === EXTENDED DUMMY PROPERTY DATA ===
const propertiesData = [
  {
    id: "PR-101",
    title: "Luxury 4BHK Golf View Villa",
    location: "Golf Course Extension, Gurugram",
    price: "₹5.50 Cr",
    status: "For Sale",
    type: "Villa",
    beds: 4, baths: 5, sqft: "4,200",
    desc: "Experience ultra-luxury living with panoramic golf course views. This independent villa features Italian marble flooring, a private terrace garden, and smart home automation.",
    amenities: ["Private Pool", "24/7 Security", "Clubhouse", "Gymnasium", "Power Backup", "Smart Home"],
    img: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=800"
  },
  {
    id: "PR-102",
    title: "Modern 3BHK Apartment",
    location: "Sector 150, Noida",
    price: "₹1.45 Cr",
    status: "For Sale",
    type: "Apartment",
    beds: 3, baths: 3, sqft: "1,850",
    desc: "A spacious and well-ventilated 3BHK apartment in a premium high-rise society. Close to the upcoming metro station and international schools.",
    amenities: ["Swimming Pool", "Kids Play Area", "Reserved Parking", "Jogging Track", "CCTV Surveillance"],
    img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800"
  },
  {
    id: "PR-103",
    title: "Fully Furnished 2BHK Flat",
    location: "Koramangala, Bengaluru",
    price: "₹45,000 / month",
    status: "For Rent",
    type: "Apartment",
    beds: 2, baths: 2, sqft: "1,200",
    desc: "Ready to move in 2BHK flat with modern wooden interiors, modular kitchen, and ACs in all rooms. Ideal for IT professionals.",
    amenities: ["Furnished", "Modular Kitchen", "Gym", "High-Speed Elevators", "Maintenance Staff"],
    img: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=800"
  },
  {
    id: "PR-104",
    title: "Premium Commercial Office",
    location: "Cyber City, Gurugram",
    price: "₹3.20 Cr",
    status: "For Sale",
    type: "Commercial",
    beds: 0, baths: 2, sqft: "2,500",
    desc: "Bare shell commercial office space in a Grade-A IT Park. Excellent connectivity and world-class infrastructure.",
    amenities: ["Central AC", "Food Court", "Conference Rooms", "Valet Parking", "Fire Safety"],
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800"
  },
  {
    id: "PR-105",
    title: "Sea Facing Penthouse",
    location: "Worli, Mumbai",
    price: "₹12.5 Cr",
    status: "For Sale",
    type: "Penthouse",
    beds: 5, baths: 6, sqft: "5,500",
    desc: "Ultra-luxurious duplex penthouse with unobstructed Arabian Sea views. Features a private deck, plunge pool, and servant quarters.",
    amenities: ["Sea View", "Private Deck", "Infinity Pool", "Concierge", "Helipad Access"],
    img: "https://images.unsplash.com/photo-1512917774073-ea26a0a7342a?q=80&w=800"
  },
  {
    id: "PR-106",
    title: "Spacious 3BHK Builder Floor",
    location: "Dwarka Sector 12, Delhi",
    price: "₹35,000 / month",
    status: "For Rent",
    type: "Builder Floor",
    beds: 3, baths: 3, sqft: "1,600",
    desc: "Newly constructed builder floor with stilt parking and lift. Close to market and park.",
    amenities: ["Lift", "Covered Parking", "Balcony", "Gated Society", "Vastu Compliant"],
    img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=800"
  }
];

const RealEstateMid: React.FC = () => {
  type Page = 'home' | 'properties' | 'about' | 'contact';
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // States for Property Listing & Filtering
  const [filter, setFilter] = useState('All');
  const [viewingProperty, setViewingProperty] = useState<any>(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
    setViewingProperty(null);
  }, [currentPage]);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsFormSubmitted(true);
    setTimeout(() => setIsFormSubmitted(false), 4000);
  };

  const filteredProperties = filter === 'All' 
    ? propertiesData 
    : propertiesData.filter(p => p.status.includes(filter) || p.type.includes(filter));

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 font-sans selection:bg-amber-200">
      
      {/* --- TOP BAR --- */}
      <div className="bg-slate-900 text-slate-300 text-[10px] md:text-xs py-2 px-4 md:px-8 flex flex-col sm:flex-row justify-between items-center tracking-widest uppercase border-b border-slate-800">
        <div className="flex gap-4">
          <span className="text-amber-500 font-bold">⭐ RERA Registered Firm</span>
          <span className="hidden sm:inline">|</span>
          <span className="hidden sm:inline">15+ Years Experience</span>
        </div>
        <div className="flex gap-4 mt-2 sm:mt-0 font-bold">
          <span>✉️ info@primeestate.in</span>
        </div>
      </div>

      {/* --- NAVBAR --- */}
      <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 md:h-24 flex items-center justify-between">
          
          <div className="flex items-center gap-3 cursor-pointer group" onClick={() => setCurrentPage('home')}>
            <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-700 text-white rounded-lg flex items-center justify-center text-xl md:text-2xl shadow-inner group-hover:bg-blue-800 transition">🏢</div>
            <div className="leading-tight">
              <span className="text-xl md:text-2xl font-black text-slate-900 tracking-tight block uppercase">Prime Estate</span>
              <span className="text-[8px] md:text-[10px] uppercase tracking-[0.2em] text-blue-600 font-bold block">Properties & Consultants</span>
            </div>
          </div>
          
          <div className="hidden lg:flex gap-8 text-xs font-bold uppercase tracking-widest text-slate-500">
            {['home', 'properties', 'about', 'contact'].map(page => (
              <button 
                key={page} 
                onClick={() => setCurrentPage(page as Page)}
                className={`hover:text-blue-700 transition ${currentPage === page ? 'text-blue-700 border-b-2 border-blue-700 pb-1' : ''}`}
              >
                {page}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button onClick={() => setCurrentPage('contact')} className="hidden sm:block bg-slate-900 text-white px-6 py-3 rounded text-xs font-bold uppercase tracking-widest hover:bg-blue-700 transition shadow-lg">
              List Your Property
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-blue-700 text-3xl">☰</button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-xl flex flex-col p-6 animate-fadeIn">
            {['home', 'properties', 'about', 'contact'].map(page => (
              <button key={page} onClick={() => setCurrentPage(page as Page)} className={`text-left py-4 text-xs font-bold uppercase tracking-widest border-b border-slate-100 ${currentPage === page ? 'text-blue-700' : 'text-slate-600'}`}>{page}</button>
            ))}
          </div>
        )}
      </nav>

      {/* --- MAIN CONTENT AREA --- */}
      <main className="flex-grow animate-fadeIn">
        
        {/* PROPERTY DETAILS OVERLAY (MODAL) */}
        {viewingProperty && (
          <div className="fixed inset-0 z-[100] flex justify-center items-center p-4 sm:p-6 overflow-y-auto">
            <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm fixed" onClick={() => setViewingProperty(null)}></div>
            <div className="relative w-full max-w-6xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col lg:flex-row max-h-[90vh] lg:max-h-none my-auto z-10 animate-slideUp">
               
               {/* Left: Image & Info */}
               <div className="lg:w-3/5 overflow-y-auto no-scrollbar border-r border-slate-200">
                  <div className="relative h-64 sm:h-96">
                     <img src={viewingProperty.img} className="w-full h-full object-cover" alt={viewingProperty.title}/>
                     <button onClick={() => setViewingProperty(null)} className="absolute top-4 left-4 bg-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-xl shadow-lg lg:hidden">×</button>
                     <div className="absolute bottom-4 left-4 bg-blue-600 text-white px-4 py-1.5 rounded text-xs font-bold uppercase tracking-widest shadow-md">
                        {viewingProperty.status}
                     </div>
                  </div>
                  <div className="p-6 md:p-8 space-y-6">
                     <div>
                       <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-2">{viewingProperty.title}</h2>
                       <p className="text-slate-500 flex items-center gap-2"><span className="text-blue-600">📍</span> {viewingProperty.location}</p>
                     </div>
                     <div className="text-3xl font-black text-amber-600">{viewingProperty.price}</div>
                     
                     <div className="grid grid-cols-3 gap-4 border-y border-slate-100 py-6">
                        <div className="text-center"><p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest mb-1">Bedrooms</p><p className="font-bold text-lg">{viewingProperty.beds}</p></div>
                        <div className="text-center border-l border-r border-slate-100"><p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest mb-1">Bathrooms</p><p className="font-bold text-lg">{viewingProperty.baths}</p></div>
                        <div className="text-center"><p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest mb-1">Super Area</p><p className="font-bold text-lg">{viewingProperty.sqft} sq.ft</p></div>
                     </div>

                     <div>
                       <h4 className="font-bold text-slate-900 uppercase tracking-widest text-sm mb-3">Description</h4>
                       <p className="text-slate-600 leading-relaxed text-sm">{viewingProperty.desc}</p>
                     </div>

                     <div>
                       <h4 className="font-bold text-slate-900 uppercase tracking-widest text-sm mb-4">Top Amenities</h4>
                       <div className="flex flex-wrap gap-2">
                         {viewingProperty.amenities.map((am: string, i: number) => (
                           <span key={i} className="bg-slate-100 text-slate-700 px-3 py-1.5 rounded text-xs font-semibold border border-slate-200 flex items-center gap-2">
                             <span className="text-blue-500">✓</span> {am}
                           </span>
                         ))}
                       </div>
                     </div>
                  </div>
               </div>

               {/* Right: Lead Form */}
               <div className="lg:w-2/5 bg-slate-50 p-6 md:p-10 flex flex-col relative">
                  <button onClick={() => setViewingProperty(null)} className="absolute top-6 right-6 text-slate-400 hover:text-slate-900 text-3xl font-light hidden lg:block">×</button>
                  <h3 className="text-xl font-black text-slate-900 mb-2 mt-4 lg:mt-0">Interested in this property?</h3>
                  <p className="text-sm text-slate-500 mb-8">Schedule a free site visit or get more details.</p>

                  {isFormSubmitted ? (
                    <div className="bg-green-100 border border-green-300 text-green-800 p-8 rounded-xl text-center flex-grow flex flex-col justify-center items-center">
                      <span className="text-5xl mb-4 block">✅</span>
                      <h4 className="font-black text-xl mb-2">Request Sent!</h4>
                      <p className="text-sm">Our agent will call you shortly regarding {viewingProperty.id}.</p>
                    </div>
                  ) : (
                    <form onSubmit={handleFormSubmit} className="space-y-5">
                      <input required type="text" placeholder="Full Name" className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded focus:border-blue-600 outline-none text-sm transition"/>
                      <input required type="tel" placeholder="Mobile Number" className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded focus:border-blue-600 outline-none text-sm transition"/>
                      <input type="email" placeholder="Email Address" className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded focus:border-blue-600 outline-none text-sm transition"/>
                      <select className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded focus:border-blue-600 outline-none text-sm text-slate-600">
                        <option>Schedule a Site Visit</option>
                        <option>Request Call Back</option>
                        <option>Get Floor Plan/Brochure</option>
                      </select>
                      <button type="submit" className="w-full bg-blue-600 text-white font-bold uppercase tracking-widest text-xs py-4 rounded hover:bg-blue-700 transition shadow-lg mt-4">
                        Submit Details
                      </button>
                      <p className="text-[10px] text-center text-slate-400 mt-4">By submitting, you agree to our privacy policy. No spam, promise.</p>
                    </form>
                  )}
               </div>
            </div>
          </div>
        )}

        {/* ================= 1. HOME PAGE ================= */}
        {currentPage === 'home' && (
          <div className="animate-slideUp">
            
            {/* Hero & Search Overlay */}
            <header className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
               <div className="absolute inset-0 z-0">
                 <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=1600" className="w-full h-full object-cover" alt="Real Estate"/>
                 <div className="absolute inset-0 bg-slate-900/60"></div>
               </div>
               
               <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center space-y-8 mt-10">
                 <h1 className="text-4xl sm:text-6xl md:text-7xl font-black text-white leading-tight">
                   Find A Place You'll <br/> <span className="text-amber-400">Love To Live.</span>
                 </h1>
                 <p className="text-slate-300 text-lg md:text-xl font-light max-w-2xl mx-auto">
                   Discover the finest apartments, villas, and commercial spaces across the city with Prime Estate's verified listings.
                 </p>
                 
                 {/* Hero Search Box */}
                 <div className="bg-white p-2 rounded-xl sm:rounded-full shadow-2xl flex flex-col sm:flex-row max-w-3xl mx-auto mt-8">
                   <select className="bg-transparent px-6 py-4 outline-none text-slate-600 font-bold border-b sm:border-b-0 sm:border-r border-slate-200 w-full sm:w-1/3">
                     <option>Buy</option><option>Rent</option><option>Commercial</option>
                   </select>
                   <input type="text" placeholder="Search locality, project or builder..." className="bg-transparent px-6 py-4 outline-none w-full sm:w-1/2 text-slate-800"/>
                   <button onClick={() => setCurrentPage('properties')} className="bg-blue-600 text-white px-8 py-4 rounded-lg sm:rounded-full font-bold uppercase tracking-widest text-xs hover:bg-blue-700 transition w-full sm:w-auto">
                     Search
                   </button>
                 </div>
               </div>
            </header>

            {/* Why Us Cards */}
            <section className="py-24 px-6 bg-white relative z-20">
               <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
                  <div className="bg-slate-50 p-10 rounded-2xl border border-slate-100 text-center hover:shadow-xl hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">🛡️</span>
                    <h3 className="text-xl font-black text-slate-900 mb-3">RERA Verified</h3>
                    <p className="text-slate-500 text-sm leading-relaxed">Every property listed with us goes through strict legal checks to ensure your investment is 100% safe.</p>
                  </div>
                  <div className="bg-slate-50 p-10 rounded-2xl border border-slate-100 text-center hover:shadow-xl hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">💰</span>
                    <h3 className="text-xl font-black text-slate-900 mb-3">Zero Brokerage Options</h3>
                    <p className="text-slate-500 text-sm leading-relaxed">We deal directly with top developers, meaning you get original bookings without paying heavy commissions.</p>
                  </div>
                  <div className="bg-slate-50 p-10 rounded-2xl border border-slate-100 text-center hover:shadow-xl hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">🤝</span>
                    <h3 className="text-xl font-black text-slate-900 mb-3">End-to-End Support</h3>
                    <p className="text-slate-500 text-sm leading-relaxed">From site visits to home loan assistance and registry paperwork, our team stands with you till you get the keys.</p>
                  </div>
               </div>
            </section>

            {/* Quick Properties Preview */}
            <section className="py-24 px-6 bg-slate-100 border-t border-slate-200">
               <div className="max-w-7xl mx-auto">
                 <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
                   <div>
                     <span className="text-blue-600 font-bold uppercase tracking-widest text-xs">Handpicked</span>
                     <h2 className="text-4xl font-black text-slate-900 mt-2">Latest Properties</h2>
                   </div>
                   <button onClick={() => setCurrentPage('properties')} className="text-slate-600 hover:text-blue-700 font-bold uppercase tracking-widest text-xs transition border-b-2 border-slate-300 hover:border-blue-700 pb-1">View All Listings</button>
                 </div>
                 
                 <div className="grid md:grid-cols-3 gap-8">
                   {propertiesData.slice(0,3).map(prop => (
                     <div key={prop.id} onClick={() => setViewingProperty(prop)} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-200 hover:shadow-2xl transition duration-300 cursor-pointer group">
                       <div className="relative h-64 overflow-hidden">
                         <img src={prop.img} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" alt={prop.title}/>
                         <div className="absolute top-4 left-4 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">{prop.status}</div>
                       </div>
                       <div className="p-6">
                         <div className="text-2xl font-black text-amber-600 mb-2">{prop.price}</div>
                         <h3 className="text-lg font-bold text-slate-900 mb-1 truncate">{prop.title}</h3>
                         <p className="text-xs text-slate-500 mb-4 truncate">📍 {prop.location}</p>
                         <div className="flex justify-between border-t border-slate-100 pt-4 text-[10px] font-bold uppercase tracking-widest text-slate-600">
                           <span>🛏️ {prop.beds} Beds</span>
                           <span>🛁 {prop.baths} Baths</span>
                           <span>📐 {prop.sqft} sqft</span>
                         </div>
                       </div>
                     </div>
                   ))}
                 </div>
               </div>
            </section>
          </div>
        )}

        {/* ================= 2. PROPERTIES PAGE (ALL LISTINGS) ================= */}
        {currentPage === 'properties' && (
          <div className="animate-slideUp pb-32">
            <div className="bg-slate-900 py-16 md:py-24 px-6 text-center text-white">
               <h1 className="text-4xl md:text-5xl font-black mb-4">Find Your Perfect Space</h1>
               <p className="text-slate-400 font-light">Explore our complete portfolio of residential and commercial real estate.</p>
            </div>
            
            <div className="max-w-7xl mx-auto px-6 mt-12">
               {/* Filters */}
               <div className="flex flex-wrap justify-center gap-4 mb-16 border-b border-slate-200 pb-8">
                 {['All', 'For Sale', 'For Rent', 'Commercial'].map(f => (
                   <button 
                    key={f} 
                    onClick={() => setFilter(f)}
                    className={`px-6 py-2.5 rounded-full text-xs font-bold uppercase tracking-widest transition ${filter === f ? 'bg-blue-600 text-white shadow-md' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}
                   >
                     {f}
                   </button>
                 ))}
               </div>

               {/* Grid */}
               <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                 {filteredProperties.map(prop => (
                   <div key={prop.id} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-200 hover:shadow-xl transition duration-300 group flex flex-col">
                     <div className="relative h-64 overflow-hidden">
                       <img src={prop.img} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" alt={prop.title}/>
                       <div className="absolute top-4 left-4 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">{prop.status}</div>
                       <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-slate-900 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">{prop.type}</div>
                     </div>
                     <div className="p-6 flex flex-col flex-grow">
                       <div className="text-2xl font-black text-amber-600 mb-2">{prop.price}</div>
                       <h3 className="text-lg font-bold text-slate-900 mb-1 line-clamp-1">{prop.title}</h3>
                       <p className="text-xs text-slate-500 mb-6 line-clamp-1">📍 {prop.location}</p>
                       
                       <div className="grid grid-cols-3 gap-2 border-y border-slate-100 py-4 mb-6 text-center text-slate-600">
                         <div><p className="text-[10px] uppercase font-bold tracking-widest mb-1">Beds</p><p className="font-bold text-sm">{prop.beds || '-'}</p></div>
                         <div className="border-l border-r border-slate-100"><p className="text-[10px] uppercase font-bold tracking-widest mb-1">Baths</p><p className="font-bold text-sm">{prop.baths}</p></div>
                         <div><p className="text-[10px] uppercase font-bold tracking-widest mb-1">Area</p><p className="font-bold text-sm">{prop.sqft}</p></div>
                       </div>
                       
                       <button onClick={() => setViewingProperty(prop)} className="mt-auto w-full bg-slate-50 border border-slate-200 text-blue-700 py-3.5 rounded text-xs font-bold uppercase tracking-widest hover:bg-blue-600 hover:text-white hover:border-blue-600 transition">
                         View Details
                       </button>
                     </div>
                   </div>
                 ))}
               </div>
            </div>
          </div>
        )}

        {/* ================= 3. ABOUT PAGE ================= */}
        {currentPage === 'about' && (
          <div className="animate-slideUp pb-32">
             <div className="bg-slate-50 py-20 px-6 text-center border-b border-slate-200">
                <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">Building Trust Since 2010.</h1>
                <p className="text-slate-500 max-w-2xl mx-auto text-lg">We don't just sell real estate; we help you find the space where your future unfolds.</p>
             </div>
             
             <div className="max-w-7xl mx-auto px-6 mt-20 grid md:grid-cols-2 gap-16 items-center">
                <div className="space-y-8">
                   <h2 className="text-3xl font-black text-slate-900">Your Transparent Real Estate Partner</h2>
                   <p className="text-slate-600 leading-relaxed">Prime Estate was founded with a single mission: to bring transparency and professionalism to the Indian real estate market. Whether you are a first-time homebuyer or a seasoned investor, our team of experts provides unbiased advice and seamless execution.</p>
                   <div className="grid grid-cols-2 gap-8 pt-4">
                      <div className="border-l-4 border-blue-600 pl-4">
                         <p className="text-3xl font-black text-slate-900">1000+</p>
                         <p className="text-xs uppercase tracking-widest text-slate-500 font-bold mt-1">Families Settled</p>
                      </div>
                      <div className="border-l-4 border-blue-600 pl-4">
                         <p className="text-3xl font-black text-slate-900">50+</p>
                         <p className="text-xs uppercase tracking-widest text-slate-500 font-bold mt-1">Builder Tie-ups</p>
                      </div>
                   </div>
                </div>
                <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
                   <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=800" className="w-full h-full object-cover" alt="Office"/>
                </div>
             </div>
          </div>
        )}

        {/* ================= 4. CONTACT PAGE ================= */}
        {currentPage === 'contact' && (
          <div className="animate-slideUp py-20 px-6">
             <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row border border-slate-100">
                <div className="md:w-2/5 bg-slate-900 p-12 text-white flex flex-col justify-center relative">
                   <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                   <div className="relative z-10 space-y-8">
                     <h2 className="text-4xl font-black leading-tight">Drop us a line or visit our office.</h2>
                     <p className="text-slate-400 font-light">Looking to sell your property or want to invest in a new project? Our experts are here to help.</p>
                     <div className="space-y-6 text-sm font-bold tracking-widest uppercase pt-4">
                        <p className="flex gap-4"><span className="text-blue-500">📍</span> DLF Cyber City, Gurugram</p>
                        <p className="flex gap-4"><span className="text-blue-500">📞</span> +91 98765 43210</p>
                        <p className="flex gap-4"><span className="text-blue-500">📧</span> sales@primeestate.in</p>
                     </div>
                   </div>
                </div>
                <div className="md:w-3/5 p-12 bg-slate-50">
                   <h3 className="text-2xl font-black text-slate-900 mb-8">Send an Enquiry</h3>
                   <form onSubmit={(e) => { e.preventDefault(); alert("Message Sent Successfully!"); }} className="space-y-6">
                      <div className="grid sm:grid-cols-2 gap-6">
                        <div><label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">Your Name</label><input required type="text" className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded-lg focus:border-blue-600 outline-none transition text-sm"/></div>
                        <div><label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">Phone Number</label><input required type="tel" className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded-lg focus:border-blue-600 outline-none transition text-sm"/></div>
                      </div>
                      <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">I am looking to</label>
                        <select className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded-lg focus:border-blue-600 outline-none transition text-sm text-slate-700">
                          <option>Buy a Property</option><option>Sell my Property</option><option>Rent a Property</option>
                        </select>
                      </div>
                      <div>
                         <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">Message</label>
                         <textarea rows={3} className="w-full bg-white border border-slate-200 px-4 py-3.5 rounded-lg focus:border-blue-600 outline-none transition text-sm resize-none"></textarea>
                      </div>
                      <button type="submit" className="w-full bg-blue-600 text-white font-bold uppercase tracking-widest text-xs py-4.5 rounded-lg hover:bg-blue-700 transition shadow-lg mt-2">Submit Message</button>
                   </form>
                </div>
             </div>
          </div>
        )}
      </main>

      {/* --- FOOTER --- */}
      <footer className="bg-slate-950 text-slate-500 py-16 px-6 border-t-4 border-blue-600 mt-auto">
         <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
            <div className="md:col-span-2 space-y-6">
               <div className="flex items-center gap-2">
                 <span className="text-2xl">🏢</span>
                 <span className="text-xl font-black text-white uppercase tracking-tight">Prime Estate</span>
               </div>
               <p className="text-sm leading-relaxed max-w-sm">Your reliable partner in real estate. We deal in luxury apartments, independent villas, and premium commercial spaces with 100% transparency.</p>
            </div>
            <div>
               <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-6">Quick Links</h4>
               <ul className="space-y-3 text-sm">
                 <li><button onClick={() => setCurrentPage('home')} className="hover:text-blue-500 transition">Home</button></li>
                 <li><button onClick={() => setCurrentPage('properties')} className="hover:text-blue-500 transition">All Properties</button></li>
                 <li><button onClick={() => setCurrentPage('about')} className="hover:text-blue-500 transition">About Us</button></li>
                 <li><button onClick={() => setCurrentPage('contact')} className="hover:text-blue-500 transition">Contact</button></li>
               </ul>
            </div>
            <div>
               <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-6">Property Types</h4>
               <ul className="space-y-3 text-sm">
                 <li><button onClick={() => { setCurrentPage('properties'); setFilter('Apartment'); }} className="hover:text-blue-500 transition">Luxury Apartments</button></li>
                 <li><button onClick={() => { setCurrentPage('properties'); setFilter('Villa'); }} className="hover:text-blue-500 transition">Independent Villas</button></li>
                 <li><button onClick={() => { setCurrentPage('properties'); setFilter('Commercial'); }} className="hover:text-blue-500 transition">Commercial Spaces</button></li>
                 <li><button onClick={() => { setCurrentPage('properties'); setFilter('For Rent'); }} className="hover:text-blue-500 transition">Properties on Rent</button></li>
               </ul>
            </div>
         </div>
         <div className="max-w-7xl mx-auto border-t border-slate-900 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-bold uppercase tracking-widest text-slate-600">
            <p>© {new Date().getFullYear()} PRIME ESTATE CONSULTANTS. ALL RIGHTS RESERVED.</p>
            <p>Real Estate Portfolio Demo</p>
         </div>
      </footer>

      {/* Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .animate-slideUp { animation: slideUp 0.5s ease-out forwards; }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />
    </div>
  );
};

export default RealEstateMid;